export default "__VITE_ASSET__awXjPI2T__"